// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SmartSurveyPushBlock-module-smartSurveyPushBlock-kqvHL{background-color:#fff;background-color:var(--des-color-fill-panel-base, #fff)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"smartSurveyPushBlock": "SmartSurveyPushBlock-module-smartSurveyPushBlock-kqvHL"
};
export default ___CSS_LOADER_EXPORT___;
